import { Component, OnInit } from '@angular/core'
import { environment } from '../environments/environment'

@Component({
  selector: 'gb-front',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'gb-front'
  footerVisibility = true

  ngOnInit(): void {
    this.addGoogleGTag()
  }

  addGoogleGTag() {
    if (environment.production) {
      this.loadScript('https://www.googletagmanager.com/gtag/js?id=G-SZRY35XB8P', true, undefined)

      this.loadScript(undefined, false, this.getGoogleTagTextScript())
    }
  }

  loadScript(url: string | undefined, async = false, text: string | undefined) {
    const script = document.createElement('script')
    script.async = async
    if (url) script.src = url
    if (text) script.text = text
    document.body.appendChild(script)
  }

  getGoogleTagTextScript() {
    return `
    window.dataLayer = window.dataLayer || []
    function gtag() {
      dataLayer.push(arguments)
    }
    gtag('js', new Date())

    gtag('config', 'G-SZRY35XB8P')
    `
  }
}
